import React, { useState } from 'react';
import { CopyText } from '../../../UiKit';
import { viewText } from '../../../images/images';
import toast from 'react-hot-toast';
import { merchantDesignationMappingWithLiterals } from '../../../constants/reasons';
import { merchantModel } from '../../../api';
import {
  MERCHANT_EVENTS,
  sendMerchantApiEvents,
} from '../../../helpers/analytics/merchant.analytics';

function unmaskNumber(orderID, designation, setNumber, setisMask) {
  const queryParams = {
    order_id: orderID,
    designation: merchantDesignationMappingWithLiterals[designation],
  };

  merchantModel
    .getMerchantNumber(queryParams)
    .then((response) => {
      if (!response || response?.isError === true) {
        return toast.error(
          response.message || 'Something went wrong. Please try again later!',
        );
      }

      sendMerchantApiEvents(
        MERCHANT_EVENTS.GET_MERCHANT_NUMBER_SUCCESS,
        orderID,
        designation,
      );
      setisMask(false);
      setNumber(response.phone);
    })
    .catch((err) => {
      toast.error(
        err.message || 'Something went wrong. Please try again later!',
      );

      sendMerchantApiEvents(
        MERCHANT_EVENTS.GET_MERCHANT_NUMBER_FAILURE,
        orderID,
        designation,
      );
    });
}

export const MerchantNumber = (props) => {
  const { phone, designation, calledTo, orderId, userId } = props;
  const [number, setNumber] = useState(phone);
  const [isMask, setisMask] = useState(true);
  return (
    <div className='tw-mr-2'>
      {isMask ? (
        <div className='tw-flex'>
          <CopyText
            dontShowCopyIcon={true}
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
            calledToType={designation}
          />
          <span
            className='pointer icon'
            onClick={() =>
              unmaskNumber(orderId, designation, setNumber, setisMask)
            }
          >
            <img src={viewText} alt='' />
          </span>
        </div>
      ) : (
        <div>
          <CopyText
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
            calledToType={designation}
          />
        </div>
      )}
    </div>
  );
};
